import React, { CSSProperties } from 'react';
import { inputStyles as styles } from './FormFieldsV3InlineStyles';
import PlaceholderStyles from './PlaceholderStyles';
import InfoAndError from './InfoAndErrorLabel';
import LabelAndTooltip from './LabelAndTooltip';
import NumberFormat, { NumberFormatValues } from 'react-number-format';

export enum INPUT_FORM_FIELD_V3_TYPES {
  TEXT = 'TEXT',
  CURRENCY = 'CURRENCY',
  PERCENTAGE = 'PERCENTAGE',
  NUMBER = 'NUMBER',
}

interface IInputProps {
  value: string;
  onChange: (value: string | number) => void;
  maxLength?: number;
  type?: INPUT_FORM_FIELD_V3_TYPES;
  currencyDecimals?: number;
  labelText?: string;
  tooltipText?: string;
  infoText?: string;
  error?: boolean;
  errorText?: string;
  placeholder?: string;
  id?: string;
  customStyles?: CSSProperties;
}

const Input = ({
  value,
  onChange,
  maxLength,
  type,
  currencyDecimals = 2,
  labelText,
  tooltipText,
  infoText,
  error,
  errorText,
  placeholder,
  id,
  customStyles,
}: IInputProps) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    onChange(e.target.value);
  };

  const handleNumberChange = (value: NumberFormatValues) =>
    onChange(value.floatValue ?? '');
  return (
    <div style={{ flex: '1', width: '100%', ...customStyles }} id={id}>
      <PlaceholderStyles />
      <LabelAndTooltip labelText={labelText} tooltipText={tooltipText} />
      {type === INPUT_FORM_FIELD_V3_TYPES.CURRENCY ? (
        <NumberFormat
          className="form-field-v3-with-placeholder"
          value={value}
          onValueChange={handleNumberChange}
          maxLength={maxLength}
          prefix="$"
          thousandSeparator=","
          decimalSeparator="."
          decimalScale={currencyDecimals}
          fixedDecimalScale={true}
          allowNegative={false}
          allowLeadingZeros={false}
          allowEmptyFormatting={false}
          placeholder={placeholder}
          style={{ ...styles.input, ...(error ? styles.error : {}) }}
        />
      ) : type === INPUT_FORM_FIELD_V3_TYPES.PERCENTAGE ? (
        <NumberFormat
          className="form-field-v3-with-placeholder"
          value={value}
          onValueChange={handleNumberChange}
          maxLength={maxLength}
          suffix="%"
          isAllowed={({ floatValue }) => {
            return floatValue === undefined || floatValue <= 100;
          }}
          placeholder={placeholder}
          style={{ ...styles.input, ...(error ? styles.error : {}) }}
        />
      ) : type === INPUT_FORM_FIELD_V3_TYPES.NUMBER ? (
        <NumberFormat
          className="form-field-v3-with-placeholder"
          value={value}
          onValueChange={handleNumberChange}
          maxLength={maxLength}
          decimalScale={0}
          fixedDecimalScale={true}
          thousandSeparator=","
          allowNegative={false}
          allowLeadingZeros={false}
          allowEmptyFormatting={false}
          placeholder={placeholder}
          style={{ ...styles.input, ...(error ? styles.error : {}) }}
        />
      ) : (
        <input
          className="form-field-v3-with-placeholder"
          style={{ ...styles.input, ...(error ? styles.error : {}) }}
          value={value}
          onChange={handleTextChange}
          maxLength={maxLength}
          placeholder={placeholder}
        />
      )}
      <InfoAndError errorText={errorText} infoText={infoText} />
    </div>
  );
};

export default Input;
